import { useTranslation } from "react-i18next";
import { CheckInRateCard } from "./components/check-in-rate-card";
import { ReservationCancellationsCard } from "./components/reservation-cancellations-card";
import { CollaboratorsCard } from "./components/collaborators-card";
import { useAuth } from "@/core/components/auth/store/auth";
import { useDashboardFilters } from "@/dashboard/store/useDashboardFilters";

export function DashboardSpaceUsageCards() {
  const [t] = useTranslation(["dashboard"]);
  const { filters } = useDashboardFilters();
  const { userInfo } = useAuth();

  const companyId = userInfo?.league?.id;

  if (!companyId) {
    return (
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-medium text-neutral-900">
            {t("dashboard-space-usage-title", "Indicadores de uso")}
          </h2>
        </div>
        <div className="grid grid-cols-[repeat(auto-fit,minmax(316px,1fr))] gap-4">
          <div className="h-48 bg-gray-200 rounded-lg animate-pulse" />
          <div className="h-48 bg-gray-200 rounded-lg animate-pulse" />
          <div className="h-48 bg-gray-200 rounded-lg animate-pulse" />
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-medium text-neutral-900">
          {t("dashboard-space-usage-title", "Indicadores de uso")}
        </h2>
      </div>

      {/* auto-fit c/ min 316px: os cards quebram de linha em vez de esmagar
          quando sidebar + painel do agente estão abertos */}
      <div className="grid grid-cols-[repeat(auto-fit,minmax(316px,1fr))] gap-4">
        <CollaboratorsCard />

        <CheckInRateCard
          startDate={filters.startDate}
          endDate={filters.endDate}
          companyId={companyId}
          cities={filters.cities?.map((c) => c.name) || null}
          spaces={filters.spaces?.map((s) => Number(s.id)) || null}
          users={
            (filters.users
              ?.map((u) => u.user?.id)
              .filter(Boolean) as number[]) || null
          }
          status={filters.status || null}
          types={filters.type || null}
          group_id={filters.group_id || null}
        />
        <ReservationCancellationsCard
          startDate={filters.startDate}
          endDate={filters.endDate}
          companyId={companyId}
          cities={filters.cities?.map((c) => c.name) || null}
          spaces={filters.spaces?.map((s) => Number(s.id)) || null}
          users={
            (filters.users
              ?.map((u) => u.user?.id)
              .filter(Boolean) as number[]) || null
          }
          status={filters.status || null}
          types={filters.type || null}
          group_id={filters.group_id || null}
        />
      </div>
    </div>
  );
}
